export default __webpack_public_path__ + "static/media/2_0016.8e894d1d.webp";